/* KÔBO — nouvelle maquette : interactions */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- NAV ---------- */
  var nav = $('#k-nav');
  if (nav) {
    var lastY = 0;
    var onScroll = function () {
      var y = window.scrollY;
      nav.classList.toggle('is-solid', y > 40);
      nav.classList.toggle('is-hidden', y > 300 && y > lastY + 4 && !document.body.classList.contains('k-lock'));
      if (y < lastY - 4 || y < 300) nav.classList.remove('is-hidden');
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var burger = $('.k-burger'), menu = $('#k-menu');
    if (burger && menu) {
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') !== 'true';
        burger.setAttribute('aria-expanded', open);
        menu.classList.toggle('is-open', open);
        document.body.classList.toggle('k-lock', open);
      });
      $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { burger.click(); }); });
    }
  }

  /* ---------- PANIER : compteur + tiroir ---------- */
  var FREE = 6000, drawer = $('#k-drawer'), lastFocus = null;
  var money = function (c, cur) { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur || 'EUR' }).format(c / 100); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };
  function render(c) {
    $$('[data-k-cart-n]').forEach(function (b) { b.textContent = c.item_count; b.setAttribute('data-n', c.item_count); });
    if (!drawer) return;
    var box = $('[data-k-lines]', drawer);
    if (!c.items.length) {
      box.innerHTML = '<div class="k-dr-empty">Votre panier est vide.<br><a class="k-btn" href="/collections/all">Découvrir les produits</a></div>';
    } else {
      box.innerHTML = c.items.map(function (i) {
        var im = i.featured_image && i.featured_image.url ? i.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
        return '<div class="k-line" data-key="' + i.key + '"><a href="' + i.url + '">' + (im ? '<img src="' + im + '" alt="' + esc(i.featured_image.alt || i.product_title) + '" width="84" height="84">' : '') + '</a>' +
          '<div><a href="' + i.url + '">' + esc(i.product_title) + '</a>' + (i.variant_title ? '<small>' + esc(i.variant_title) + '</small>' : '') +
          '<div class="q"><button type="button" data-q="-1" aria-label="Moins">−</button><span>' + i.quantity + '</span><button type="button" data-q="1" aria-label="Plus">+</button></div></div>' +
          '<div><div class="pr">' + money(i.final_line_price, c.currency) + '</div><button class="rm" type="button" data-rm>Retirer</button></div></div>';
      }).join('');
    }
    $('[data-k-total]', drawer).textContent = money(c.total_price, c.currency);
    var left = FREE - c.total_price, bar = $('[data-k-shipbar]', drawer), t = $('[data-k-ship]', drawer);
    bar.style.width = Math.min(100, c.total_price / FREE * 100) + '%';
    t.innerHTML = c.item_count === 0 ? 'Livraison offerte dès <b>60&nbsp;€</b>' : (left > 0 ? 'Plus que <b>' + money(left, c.currency) + '</b> pour la livraison offerte' : '<svg class="k-ico" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg> <b>Livraison offerte</b>');
    $('[data-k-checkout]', drawer).disabled = !c.items.length;
  }
  function refresh() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }).catch(function () {}); }
  function openDrawer() { if (!drawer) return; lastFocus = document.activeElement; refresh(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('k-lock'); var cl = $('.k-dr-h button', drawer); if (cl) cl.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('k-lock'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  function change(key, q) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }).then(function (r) { return r.json(); }).then(render); }
  window.koboCartCount = refresh;
  window.koboCart = {
    refresh: refresh, open: openDrawer, close: closeDrawer,
    add: function (items) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) { return refresh().then(function () { return j; }); });
    },
    toast: function (msg) { var t = $('.k-toast') || document.body.appendChild(Object.assign(document.createElement('div'), { className: 'k-toast', role: 'status' })); t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2600); }
  };
  if (drawer) {
    document.addEventListener('click', function (e) {
      var c = e.target.closest('.k-cart, #k-menu a[href$="/cart"]');
      if (c && location.pathname.indexOf('/cart') !== 0) { e.preventDefault(); var m = $('#k-menu.is-open'); if (m) { var bb = $('.k-burger'); bb && bb.click(); } openDrawer(); return; }
      if (e.target.closest('[data-k-close]')) closeDrawer();
      var line = e.target.closest('.k-line'); if (!line) return;
      var qb = e.target.closest('[data-q]'), rm = e.target.closest('[data-rm]');
      var qty = +$('.q span', line).textContent;
      if (qb) change(line.getAttribute('data-key'), qty + (+qb.getAttribute('data-q')));
      if (rm) change(line.getAttribute('data-key'), 0);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  refresh();

  /* ---------- FOOTER : mot KÔBO animé ---------- */
  var fbig = $('.k-foot-big');
  if (fbig && 'IntersectionObserver' in window) { var fio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { fbig.classList.add('is-in'); fio.disconnect(); } }); }, { threshold: 0.25 }); fio.observe(fbig); } else if (fbig) fbig.classList.add('is-in');

  /* ---------- REVEAL ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;
  $$('.k-reveal').forEach(function (el, i) { if (io) io.observe(el); else el.classList.add('is-in'); });

  /* ---------- INTRO : logo pointillé ---------- */
  var intro = $('.k-intro canvas');
  if (intro) {
    var ctx = intro.getContext('2d');
    var W, H, pts = [], dpr = Math.min(window.devicePixelRatio || 1, 2), mouse = { x: -999, y: -999 };
    var word = intro.getAttribute('data-word') || 'KOBO';
    var build = function () {
      var r = intro.getBoundingClientRect();
      W = intro.width = Math.round(r.width * dpr); H = intro.height = Math.round(r.height * dpr);
      var off = document.createElement('canvas'); off.width = W; off.height = H;
      var o = off.getContext('2d');
      var fs = Math.min(W * 0.34, H * 0.34);
      o.fillStyle = '#fff'; o.textAlign = 'center'; o.textBaseline = 'middle';
      o.font = '900 ' + fs + 'px Inter, Helvetica, Arial, sans-serif';
      if ('letterSpacing' in o) o.letterSpacing = (fs * 0.06) + 'px';
      o.fillText(word, W / 2, H / 2);
      var d = o.getImageData(0, 0, W, H).data, step = Math.max(3, Math.round(3.2 * dpr));
      pts = [];
      for (var y = 0; y < H; y += step) for (var x = 0; x < W; x += step) {
        if (d[(y * W + x) * 4 + 3] > 128) pts.push({ x: x, y: y, ox: x, oy: y, vx: 0, vy: 0, p: Math.random(), s: Math.random() < .25 ? 2 : 1 });
      }
    };
    build();
    window.addEventListener('resize', build);
    intro.addEventListener('pointermove', function (e) { var r = intro.getBoundingClientRect(); mouse.x = (e.clientX - r.left) * dpr; mouse.y = (e.clientY - r.top) * dpr; });
    intro.addEventListener('pointerleave', function () { mouse.x = mouse.y = -999; });
    var t0 = performance.now(), vis = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { vis = e[0].isIntersecting; }).observe(intro);
    var R = 110 * dpr;
    var frame = function (now) {
      requestAnimationFrame(frame);
      if (!vis) return;
      var t = (now - t0) / 1000, build01 = Math.min(1, t / 2.6);
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = '#fff';
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i];
        var dx = p.x - mouse.x, dy = p.y - mouse.y, dd = dx * dx + dy * dy;
        if (dd < R * R) { var f = (1 - Math.sqrt(dd) / R) * 5; var a = Math.atan2(dy, dx); p.vx += Math.cos(a) * f; p.vy += Math.sin(a) * f; }
        p.vx += (p.ox - p.x) * 0.06; p.vy += (p.oy - p.y) * 0.06; p.vx *= 0.82; p.vy *= 0.82;
        p.x += p.vx; p.y += p.vy;
        var tw = 0.5 + 0.5 * Math.sin(t * 2.2 + p.p * 40);
        var alpha = (p.p < build01 ? 0.42 + 0.5 * tw : 0) * (0.85 + 0.15 * Math.sin(t + p.p * 9));
        if (alpha <= 0.02) continue;
        ctx.globalAlpha = alpha;
        ctx.fillRect(p.x, p.y, p.s * dpr, p.s * dpr);
      }
      ctx.globalAlpha = 1;
    };
    if (reduce) { t0 -= 5000; }
    requestAnimationFrame(frame);
  }

  /* ---------- MIX : images déplaçables + mots ---------- */
  var mix = $('.k-mix');
  if (mix) {
    var imgs = $$('.k-mix-img', mix), z = 5;
    var place = function () {
      var r = mix.getBoundingClientRect(), n = imgs.length;
      var slots = [[.06, .16], [.74, .1], [.02, .58], [.8, .56], [.4, .68], [.24, .04], [.58, .02], [.9, .3]];
      imgs.forEach(function (im, i) {
        var s = slots[i % slots.length], w = im.offsetWidth, h = im.offsetHeight;
        im.style.left = Math.max(0, Math.min(r.width - w, s[0] * r.width)) + 'px';
        im.style.top = Math.max(0, Math.min(r.height - h, s[1] * r.height)) + 'px';
        im.style.rotate = (i % 2 ? 1 : -1) * (2 + (i * 3) % 6) + 'deg';
      });
    };
    if (imgs[0]) { if (imgs[0].complete) place(); else window.addEventListener('load', place); place(); }
    window.addEventListener('resize', place);
    imgs.forEach(function (im) {
      var sx, sy, ox, oy, drag = false;
      im.addEventListener('pointerdown', function (e) {
        drag = true; im.setPointerCapture(e.pointerId); im.classList.add('is-drag'); im.style.zIndex = ++z;
        sx = e.clientX; sy = e.clientY; ox = im.offsetLeft; oy = im.offsetTop; e.preventDefault();
      });
      im.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var r = mix.getBoundingClientRect();
        im.style.left = Math.max(-40, Math.min(r.width - im.offsetWidth + 40, ox + e.clientX - sx)) + 'px';
        im.style.top = Math.max(-20, Math.min(r.height - im.offsetHeight + 20, oy + e.clientY - sy)) + 'px';
      });
      var end = function () { drag = false; im.classList.remove('is-drag'); };
      im.addEventListener('pointerup', end); im.addEventListener('pointercancel', end);
    });
    var wb = $('.k-mix-copy p b', mix);
    if (wb) {
      var words = (wb.getAttribute('data-words') || '').split('|'), wi = 0;
      if (words.length > 1) setInterval(function () {
        wb.classList.add('is-out');
        setTimeout(function () { wi = (wi + 1) % words.length; wb.textContent = words[wi]; wb.classList.remove('is-out'); }, 350);
      }, 2200);
    }
  }

  /* ---------- PRODUIT ---------- */
  var form = $('#k-buy');
  if (form) {
    var data = JSON.parse($('#k-variants').textContent);
    var price = $('[data-k-price]'), btn = $('[data-k-atc]'), msg = $('.k-msg'), vid = $('input[name=id]', form);
    var sticky = $('.k-sticky-atc'), sprice = $('[data-k-sprice]');
    var fmt = function (c) { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: form.getAttribute('data-currency') || 'EUR' }).format(c / 100); };
    var current = function () {
      var sel = $$('.k-opt input:checked', form).map(function (i) { return i.value; });
      if (!sel.length) return data[0];
      return data.filter(function (v) { return v.options.join('|') === sel.join('|'); })[0];
    };
    var sync = function () {
      var v = current();
      if (!v) { btn.setAttribute('disabled', ''); btn.querySelector('span').textContent = 'Indisponible'; return; }
      vid.value = v.id;
      var html = fmt(v.price) + (v.compare_at_price > v.price ? ' <s>' + fmt(v.compare_at_price) + '</s>' : '');
      price.innerHTML = html; if (sprice) sprice.textContent = fmt(v.price);
      if (v.available) { btn.removeAttribute('disabled'); btn.querySelector('span').textContent = 'Ajouter au panier'; }
      else { btn.setAttribute('disabled', ''); btn.querySelector('span').textContent = 'Épuisé'; }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      document.dispatchEvent(new CustomEvent('k:variant', { detail: v }));
    };
    $$('.k-opt input', form).forEach(function (i) { i.addEventListener('change', sync); });
    var q = $('input[name=quantity]', form);
    $$('[data-q]', form).forEach(function (b) { b.addEventListener('click', function () { q.value = Math.max(1, (+q.value || 1) + (+b.getAttribute('data-q'))); }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.hasAttribute('disabled')) return;
      var label = btn.querySelector('span'); label.textContent = 'Ajout…';
      window.koboCart.add([{ id: +vid.value, quantity: +q.value || 1 }])
        .then(function () { label.innerHTML = 'Ajouté <svg class="k-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg>'; msg.textContent = ''; window.koboCart.open(); setTimeout(function () { label.textContent = 'Ajouter au panier'; }, 2200); })
        .catch(function (err) { label.textContent = 'Ajouter au panier'; msg.textContent = (err && err.description) || 'Impossible d’ajouter ce produit.'; });
    });
    if (sticky) {
      $('[data-k-satc]', sticky).addEventListener('click', function () { form.requestSubmit(); });
      new IntersectionObserver(function (e) { sticky.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(btn);
    }
    sync();
  }
})();
